// extracted by mini-css-extract-plugin
export default {"container":"EmployersScreen_container__GXcn-"};